module.exports = __webpack_public_path__ + "static/img/flyer.471349e6.png";